


































































import Vue from "vue";
import axios from "axios";

// Codemirror dependencies.
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/sql/sql.js';
import 'codemirror/theme/monokai.css';

import './css/covered-wide.css';

export default Vue.extend({
  data() {
    return {
      error: null,
      sqlError: null,
      session: null,
      connection: null,
      sqlCode: "SELECT 1",
      challengeNumber: 1,
      sqlRunning: false,
      results: null,
      challengeTitle: "How many users?",
      challengeBrief: "What's going on with the users.",
      challengeTables: ["users", "orders"],
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: 'sql',
        theme: 'monokai',
        lineNumbers: true,
        line: true,
        lineWrapping: true,
      }
    };
  },

  components: {
    codemirror
  },

  async created() {
    // On page load, set up the connection
    let searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('code')) {
      this.error = "No Code";
      console.log(this.error);
    } else {
      var code = searchParams.get('code');
      if (code != 'demo' && code != 'tails') {
        this.error = "WRONG CODE";
        console.log(this.error);
      } else {
        this.session = code;
        axios
          .get(process.env.API_URL + "/session/" + this.session + "/connection")
          .then(response => {
              console.log("Successful GET to /session/x/connection");
              console.log(response);
              this.connection = response.data;
          })
          .catch(error => {
              // Wu oh! Something went wrong
              this.error = "Failed GET to /session/x/connection";
              console.log(this.error);
          });

      }
    }
  },

  methods: {
    runSql () {
      this.sqlRunning = true;
      this.sqlError = null;
      axios
        .post(process.env.API_URL + "/session/" + this.session + "/query?sql=" + encodeURI(this.sqlCode))
        .then(response => {
            console.log("Successful POST to /session/x/query");
            console.log(response);
            this.results = response.data;
            this.sqlRunning = false;
        })
        .catch(error => {
            // Wu oh! Something went wrong
            
            if (error.response.status == 400) {
              console.log("Bad Query.");
              this.sqlError = error.response.data.Message;
              this.sqlRunning = false;
            } else {
              console.log("Other...");
              this.error = "Failed POST to /session/x/query";
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
              console.log(this.error);
            }
        });

    }
  }
});

